import { useMemo } from "react"

import { useFollowUpConfigurationsQuery } from "../graphql/queries.generated"

export function useFollowUpConfigurations() {
  const { data, loading, error, refetch } = useFollowUpConfigurationsQuery()

  const followUpConfigurations = useMemo(
    () => data?.followUpConfigurations ?? [],
    [data?.followUpConfigurations]
  )

  return { followUpConfigurations, isLoading: loading, error, refetch }
}
